
<script>

    import { getContext } from "svelte";
    import {
        sessionCleanup
    } from "../utils/session";


    const router = getContext('router');

    export let active;

    $: isActive = (str) => active === str ? 'active' : '';

    let logoutHandler = () => {

        sessionCleanup();
        router.route('/login')

    };

    const HIDDEN_NAV_ROUTES = ['login'];

    let routeTo = (link) => {

        router.route(link)
    }

</script>

{#if !HIDDEN_NAV_ROUTES.includes(active)}
    <nav>

        <div id="nav-container">

            <div id="nav-logo-container">

                <img src="/images/logo.png" alt="Logo">

                <h2>Ämtler-Bon</h2>

            </div>

            <ul id="primary" class="nav">

                <li id="nav-dashboard" class="{isActive('dashboard')}" on:click={() => routeTo('/')}>

                    <div class="img-container">
                        <img src="/images/icons/dashboard.svg" alt="">
                    </div>

                    <div class="nav-element">Dashboard</div>

                </li>

                <li id="nav-members" class="{isActive('members')}" on:click={() => routeTo('/members')}>

                    <div class="img-container">
                        <img src="/images/icons/store.svg" alt="">
                    </div>

                    <div class="nav-element">Mitglieder</div>

                </li>

                <li id="nav-users" class="{isActive('users')}" on:click={() => routeTo('/users')}>

                    <div class="img-container">
                        <img src="/images/icons/users.svg" alt="">
                    </div>

                    <div class="nav-element">Benutzer</div>

                </li>

                <li id="nav-payouts" class="{isActive('payouts')}" on:click={() => routeTo('/payouts')}>

                    <div class="img-container">
                        <img src="/images/icons/transactions.svg" alt="">
                    </div>

                    <div class="nav-element">Auszahlungen</div>

                </li>

            </ul>

            <ul id="secondary" class="nav">

<!--                <li id="nav-notifications">-->

<!--                    <div class="img-container">-->
<!--                        <img src="/images/icons/notifications.svg" alt="">-->
<!--                    </div>-->

<!--                    <div class="nav-element">Benachrichtigungen</div>-->

<!--                </li>-->

                <li on:click={() => logoutHandler()}>

                    <div class="img-container">
                        <img src="/images/icons/logout.svg" alt="">
                    </div>

                    <div class="nav-element" style="color: red">Abmelden</div>

                </li>

            </ul>

        </div>



    </nav>
{/if}


<style>

    nav {
        position: fixed;
        display: flex;
        flex-direction: column;
        width: 27.6vh;
        height: 100vh;
        background-color: white;
        z-index: 9;
    }

    nav #nav-container {
        display: flex;
        flex-direction: column;
        height: inherit;
        justify-content: space-around;
    }

    nav #nav-container #nav-logo-container {
        display: flex;
        flex-direction: column;
        align-items: center;

    }

    nav #nav-container #nav-logo-container img {
        height: 12vh;
    }

    nav #nav-container #nav-logo-container h2 {
        font-family: 'Urbanist', sans-serif;
        font-size: 2.5vh;
    }

    nav ul {
        display: flex;
        flex-direction: column;
        width: inherit;
        padding: 0;
        list-style-type: none;
        align-items: center;
        margin: 0;
    }

    nav #nav-container ul.nav li {
        position: relative;
        display: flex;
        width: 23vh;
        background-color: #FAFAFB;
        margin: 1.5vh 0;
        border-radius: 2vh;
        align-items: center;
        -webkit-box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.08);
        -moz-box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.08);
        box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.08);
        transition: ease 0.3s;
        cursor: pointer;
    }

    nav #nav-container ul.nav li:hover {
        transform: scale(1.05);
        -webkit-box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.2);
        -moz-box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.2);
        box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.2);
    }

    .nav li .nav-element,
    .nav li a {
        display: flex;
        width: inherit;
        padding: 2vh 0;
        justify-content: flex-start;
        font-family: 'Urbanist', sans-serif;
        font-size: 1.6vh;
    }

    #secondary.nav li .nav-element,
    #secondary.nav li a {
        padding: 2vh 0;
        font-size: 1.6vh;
        font-family: 'Urbanist', sans-serif;
    }

    .nav li .img-container {
        height: 3.5vh;
        width: 11vh;
        display: flex;
        justify-content: center;
    }

    .nav li .img-container img {
        height: 100%;
    }

</style>
